import { ApolloQueryResult } from '@apollo/client';
import { useAuth } from '../../contexts/AuthContext';
import { GetCurrentUser, GetCurrentUser_currentUser } from '../../interfaces/graphql';
import { useClientHasRendered } from '../hooks';

export type CurrentUser = GetCurrentUser_currentUser | null | undefined;

export interface UseUserInfo {
  isLoggedIn: boolean;
  isPremium: boolean;
  isVerified: boolean;
  user: CurrentUser;
  premiumEndDate: string | undefined;
  isLoadingUser: boolean;
  refetchCurrentUser: () => Promise<ApolloQueryResult<GetCurrentUser>>;
}

export function useUserInfo(): UseUserInfo {
  const { isLoggedIn, currentUser, refetchCurrentUser, isLoadingUser, premiumEndDate } = useAuth();
  const clientHasRendered = useClientHasRendered();

  return {
    isLoadingUser: clientHasRendered && isLoadingUser,
    isLoggedIn: clientHasRendered && isLoggedIn,
    isPremium: !!currentUser?.isPremium,
    isVerified: !!currentUser?.isVerified,
    user: currentUser,
    premiumEndDate,
    refetchCurrentUser,
  };
}
